export default "__VITE_ASSET__ANFWL18k__"